var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook-brands",
    d: "M24,33.323V54.671a1.323,1.323,0,0,1-1.323,1.323H16.559V46.705h3.118l.466-3.621H16.554V40.77c0-1.05.289-1.763,1.795-1.763h1.918V35.766a25.784,25.784,0,0,0-2.8-.145c-2.764,0-4.661,1.688-4.661,4.789v2.673H9.68v3.621h3.129V56H1.323A1.326,1.326,0,0,1,0,54.677V33.323A1.326,1.326,0,0,1,1.323,32H22.671A1.327,1.327,0,0,1,24,33.323Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBrands);
export default __webpack_public_path__ + "static/media/facebook-brands.9a97e98af6bf6eb2e38eef4edb2333d0.svg";
export { ForwardRef as ReactComponent };